import React from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

function StepFullParticipants(props) {
    const {eventId} = props,
        i18n = useI18n();

    return <StartNetworkingStep href={`/events/${eventId}/participants`}>{i18n['start.full_participants_list']}</StartNetworkingStep>;
}

export default StepFullParticipants;
